/**
 * Ce que fait le bouton d'ajout de `<MediaPicker>` : ouvrir la feuille des sources, ou, au web, la
 * seule source qu'elle aurait proposée (Aziz, 20/10 : « Joindre une capture ou une vidéo » ouvrait
 * une feuille à une seule option, « Choisir un fichier »). Le web n'a souvent qu'elle (pas de galerie,
 * pas d'appareil photo) : passer par la feuille n'ajoutait qu'un toucher.
 *
 * La source part dans le même toucher que le bouton : au web, un sélecteur de fichiers ouvert hors d'un
 * geste de l'utilisateur est bloqué par le navigateur. Pure, testée à part (l'organisme ne se charge pas
 * sous Jest).
 */
export type MediaMenuItem = { onPress: () => void }

/** Au web, une feuille à une seule source : cette source. Sinon `null`, la feuille s'ouvre. */
export function soleMediaSource<T extends MediaMenuItem>(items: T[], web: boolean): T | null {
    return web && items.length === 1 ? items[0]! : null
}
